// extracted by mini-css-extract-plugin
export default {"PageImageShow":"index_PageImageShow__8BULK"};